import { render, staticRenderFns } from "./PageSchoolCalendarEdit.vue?vue&type=template&id=82d13042&scoped=true"
import script from "./PageSchoolCalendarEdit.vue?vue&type=script&lang=js"
export * from "./PageSchoolCalendarEdit.vue?vue&type=script&lang=js"
import style0 from "./PageSchoolCalendarEdit.vue?vue&type=style&index=0&id=82d13042&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d13042",
  null
  
)

export default component.exports